import React from 'react'

import {
  faAward,
  faBriefcase,
  faCalendar,
  faHashtag,
  faHistory,
  faMap,
  faTools,
  faUniversity,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Typography } from '@material-ui/core'
import { get, isUndefined, reject } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getCareerSearchURL } from 'common/career-search-predefined-search-helpers'
import { getCollegeSearchURL } from 'common/college-search-predefined-search-helpers'
import {
  CAREER_AND_TRADE,
  FOUR_YEAR_US,
  FOUR_YEAR_US_OLD,
  INTERNATIONAL,
  MIDWEST,
  NORTHEAST,
  SOUTH,
  TEST_OPTIONAL,
  TWO_YEAR_US,
  TWO_YEAR_US_OLD,
  WEST,
} from 'common/predefined-college-searches'
import { EVENT_CLICK_SOURCES } from 'common/track-event-constants'
import { useIsAuthed } from 'components/AuthShield'
import { FEATURE_NAMES } from 'components/ConfiguredDynamicFeatureProvider/features'
import { useIsDynamicFeatureEnabled } from 'components/DynamicFeatureProvider/use-is-dynamic-feature-enabled'
import { isTnTSearchFilterEnabled } from 'store/feature-toggle'
import { selectSavedPublicCollegeSearch } from 'store/saved-public-college-search'

import SearchButton from './SearchButton'

export const getOptions = ({
  savedSearch,
  pathname,
  isAuthed,
  eventsDynamicFeatureEnabled,
  tntSearchFilterEnabled,
}) => {
  return reject(
    [
      {
        label: 'My Last Search',
        to: getCollegeSearchURL({ source: EVENT_CLICK_SOURCES.PREDEFINED_SEARCH }),
        show: !isUndefined(savedSearch) && pathname !== getCollegeSearchURL(),
        startIcon: <FontAwesomeIcon icon={faHistory} />,
      },
      {
        label: '4-Year US',
        to: getCollegeSearchURL({ predefinedFilters: FOUR_YEAR_US_OLD, source: EVENT_CLICK_SOURCES.PREDEFINED_SEARCH }),
        startIcon: <FontAwesomeIcon icon={faUniversity} />,
        show: !tntSearchFilterEnabled,
      },
      {
        label: '2-Year US',
        to: getCollegeSearchURL({ predefinedFilters: TWO_YEAR_US_OLD, source: EVENT_CLICK_SOURCES.PREDEFINED_SEARCH }),
        startIcon: <FontAwesomeIcon icon={faUniversity} />,
        show: !tntSearchFilterEnabled,
      },
      {
        label: '4-Year US',
        to: getCollegeSearchURL({ predefinedFilters: FOUR_YEAR_US, source: EVENT_CLICK_SOURCES.PREDEFINED_SEARCH }),
        startIcon: <FontAwesomeIcon icon={faUniversity} />,
        show: tntSearchFilterEnabled,
      },
      {
        label: '2-Year US',
        to: getCollegeSearchURL({ predefinedFilters: TWO_YEAR_US, source: EVENT_CLICK_SOURCES.PREDEFINED_SEARCH }),
        startIcon: <FontAwesomeIcon icon={faUniversity} />,
        show: tntSearchFilterEnabled,
      },
      {
        label: 'Career & Trade',
        to: getCollegeSearchURL({ predefinedFilters: CAREER_AND_TRADE, source: EVENT_CLICK_SOURCES.PREDEFINED_SEARCH }),
        startIcon: <FontAwesomeIcon icon={faTools} />,
        show: tntSearchFilterEnabled,
      },
      {
        label: 'International',
        to: getCollegeSearchURL({ predefinedFilters: INTERNATIONAL, source: EVENT_CLICK_SOURCES.PREDEFINED_SEARCH }),
        startIcon: <FontAwesomeIcon icon={faUniversity} />,
      },
      {
        label: 'Test-Optional',
        to: getCollegeSearchURL({ predefinedFilters: TEST_OPTIONAL, source: EVENT_CLICK_SOURCES.PREDEFINED_SEARCH }),
        startIcon: <FontAwesomeIcon icon={faUniversity} />,
      },
      {
        label: 'Virtual Tour',
        eventDataLabel: '# Virtual Tour',
        to: `${import.meta.env.BASE_URL}/discover/posts?source=${
          EVENT_CLICK_SOURCES.PREDEFINED_SEARCH
        }&tag=Virtual%20Tour`,
        show: isAuthed,
        startIcon: <FontAwesomeIcon icon={faHashtag} />,
      },
      {
        label: 'Housing',
        eventDataLabel: '# Housing',
        to: `${import.meta.env.BASE_URL}/discover/posts?source=${EVENT_CLICK_SOURCES.PREDEFINED_SEARCH}&tag=Housing`,
        show: isAuthed,
        startIcon: <FontAwesomeIcon icon={faHashtag} />,
      },
      {
        label: 'Dorms',
        eventDataLabel: '# Dorms',
        to: `${import.meta.env.BASE_URL}/discover/posts?source=${EVENT_CLICK_SOURCES.PREDEFINED_SEARCH}&tag=Dorms`,
        show: isAuthed,
        startIcon: <FontAwesomeIcon icon={faHashtag} />,
      },
      {
        label: 'Study Abroad',
        eventDataLabel: '# Study Abroad',
        to: `${import.meta.env.BASE_URL}/discover/posts?source=${
          EVENT_CLICK_SOURCES.PREDEFINED_SEARCH
        }&tag=Study%20Abroad`,
        show: isAuthed,
        startIcon: <FontAwesomeIcon icon={faHashtag} />,
      },
      {
        label: 'Scholarships',
        eventDataLabel: '# Scholarships',
        to: `${import.meta.env.BASE_URL}/discover/posts?source=${
          EVENT_CLICK_SOURCES.PREDEFINED_SEARCH
        }&tag=Scholarships`,
        show: isAuthed,
        startIcon: <FontAwesomeIcon icon={faHashtag} />,
      },
      {
        label: 'Events',
        eventDataLabel: 'Upcoming Events',
        to: `${import.meta.env.BASE_URL}/discover/events?source=${EVENT_CLICK_SOURCES.PREDEFINED_SEARCH}`,
        show: isAuthed && eventsDynamicFeatureEnabled,
        startIcon: <FontAwesomeIcon icon={faCalendar} />,
      },
      {
        label: 'Pre-College Programs',
        eventDataLabel: 'Pre-College Programs',
        to: `${import.meta.env.BASE_URL}/discover/programs?source=${EVENT_CLICK_SOURCES.PREDEFINED_SEARCH}`,
        show: isAuthed,
        startIcon: <FontAwesomeIcon icon={faAward} />,
      },
      {
        label: 'All Careers',
        to: getCareerSearchURL(), //Add careers LINK
        show: isAuthed,
        startIcon: <FontAwesomeIcon icon={faBriefcase} />,
      },
    ],
    (x) => x.show === false,
  )
}
export const getDashboardOptions = ({
  savedSearch,
  pathname,
  isAuthed,
  // eventsDynamicFeatureEnabled,
  tntSearchFilterEnabled,
}) => {
  return reject(
    [
      {
        label: 'My Last Search',
        to: getCollegeSearchURL({ source: EVENT_CLICK_SOURCES.DASHBOARD }),
        show: !isUndefined(savedSearch) && pathname !== getCollegeSearchURL(),
        startIcon: <FontAwesomeIcon icon={faHistory} />,
        careerSearch: false,
      },
      {
        label: '4-Year US',
        to: getCollegeSearchURL({ predefinedFilters: FOUR_YEAR_US_OLD, source: EVENT_CLICK_SOURCES.DASHBOARD }),
        startIcon: <FontAwesomeIcon icon={faUniversity} />,
        show: !tntSearchFilterEnabled,
      },
      {
        label: '2-Year US',
        to: getCollegeSearchURL({ predefinedFilters: TWO_YEAR_US_OLD, source: EVENT_CLICK_SOURCES.DASHBOARD }),
        startIcon: <FontAwesomeIcon icon={faUniversity} />,
        show: !tntSearchFilterEnabled,
      },
      {
        label: '4-Year US',
        to: getCollegeSearchURL({ predefinedFilters: FOUR_YEAR_US, source: EVENT_CLICK_SOURCES.DASHBOARD }),
        startIcon: <FontAwesomeIcon icon={faUniversity} />,
        show: tntSearchFilterEnabled,
      },
      {
        label: '2-Year US',
        to: getCollegeSearchURL({ predefinedFilters: TWO_YEAR_US, source: EVENT_CLICK_SOURCES.DASHBOARD }),
        startIcon: <FontAwesomeIcon icon={faUniversity} />,
        show: tntSearchFilterEnabled,
      },
      {
        label: 'Career & Trade',
        to: getCollegeSearchURL({ predefinedFilters: CAREER_AND_TRADE, source: EVENT_CLICK_SOURCES.DASHBOARD }),
        startIcon: <FontAwesomeIcon icon={faTools} />,
        show: tntSearchFilterEnabled,
      },
      {
        label: 'International',
        to: getCollegeSearchURL({ predefinedFilters: INTERNATIONAL, source: EVENT_CLICK_SOURCES.DASHBOARD }),
        startIcon: <FontAwesomeIcon icon={faUniversity} />,
      },
      {
        label: 'Test-Optional',
        to: getCollegeSearchURL({ predefinedFilters: TEST_OPTIONAL, source: EVENT_CLICK_SOURCES.DASHBOARD }),
        startIcon: <FontAwesomeIcon icon={faUniversity} />,
      },
      {
        label: 'Northeast',
        to: getCollegeSearchURL({ predefinedFilters: NORTHEAST, source: EVENT_CLICK_SOURCES.DASHBOARD }),
        startIcon: (
          <Box>
            <FontAwesomeIcon
              size="sm"
              icon={faMap}
            />
          </Box>
        ),
      },
      {
        label: 'South',
        to: getCollegeSearchURL({ predefinedFilters: SOUTH, source: EVENT_CLICK_SOURCES.DASHBOARD }),
        startIcon: (
          <Box>
            <FontAwesomeIcon
              size="sm"
              icon={faMap}
            />
          </Box>
        ),
      },
      {
        label: 'West',
        to: getCollegeSearchURL({ predefinedFilters: WEST, source: EVENT_CLICK_SOURCES.DASHBOARD }),
        startIcon: (
          <Box>
            <FontAwesomeIcon
              size="sm"
              icon={faMap}
            />
          </Box>
        ),
      },
      {
        label: 'Midwest',
        to: getCollegeSearchURL({ predefinedFilters: MIDWEST, source: EVENT_CLICK_SOURCES.DASHBOARD }),
        startIcon: (
          <Box>
            <FontAwesomeIcon
              size="sm"
              icon={faMap}
            />
          </Box>
        ),
      },
      {
        label: 'All Careers',
        to: getCareerSearchURL(), //Add careers LINK
        show: isAuthed,
        startIcon: <FontAwesomeIcon icon={faBriefcase} />,
        careerSearch: true,
      },
    ],
    (x) => x.show === false,
  )
}

export const StartYourSearch = ({
  condensed = false,
  dashboardOptions,
  savedSearch,
  savedPublicCollegeSearch,
  pathname,
  onSelect,
  tntSearchFilterEnabled,
}) => {
  const isAuthed = useIsAuthed()
  const hasEventSearch = useIsDynamicFeatureEnabled(FEATURE_NAMES.EventSearch)
  const options = dashboardOptions
    ? getDashboardOptions({
        savedSearch: isAuthed ? savedSearch : savedPublicCollegeSearch,
        pathname,
        isAuthed,
        eventsDynamicFeatureEnabled: hasEventSearch,
        tntSearchFilterEnabled,
      })
    : getOptions({
        savedSearch: isAuthed ? savedSearch : savedPublicCollegeSearch,
        pathname,
        isAuthed,
        eventsDynamicFeatureEnabled: hasEventSearch,
        tntSearchFilterEnabled,
      })
  return (
    <Box
      mt={2}
      width="100%"
    >
      <Typography
        variant={condensed ? 'subtitle2' : 'h6'}
        color={'textPrimary'}
      >
        {dashboardOptions ? 'All caught up! Explore colleges, careers, and more.' : 'Start your search'}
      </Typography>
      <Box
        width="100%"
        pt={2.5}
      >
        {options
          .filter(({ careerSearch }) => !careerSearch)
          .map(({ label, to, startIcon, eventDataLabel }, idx) => {
            return (
              <Box
                key={idx}
                pr={1}
                pb={condensed ? 1 : 2}
                display="inline-flex"
              >
                <SearchButton
                  label={label}
                  eventDataLabel={eventDataLabel}
                  to={to}
                  condensed={condensed}
                  startIcon={startIcon}
                  onSelect={onSelect}
                />
              </Box>
            )
          })}
        {dashboardOptions &&
          options
            .filter(({ careerSearch }) => !!careerSearch)
            .map(({ label, to, startIcon, eventDataLabel }, idx) => {
              return (
                <Box
                  key={idx}
                  pr={1}
                  pb={condensed ? 1 : 2}
                  display="inline-flex"
                >
                  <SearchButton
                    label={label}
                    eventDataLabel={eventDataLabel}
                    to={to}
                    condensed={condensed}
                    startIcon={startIcon}
                    onSelect={onSelect}
                  />
                </Box>
              )
            })}
      </Box>
    </Box>
  )
}

StartYourSearch.propTypes = {
  condensed: PropTypes.bool,
  dashboardOptions: PropTypes.bool,
  savedSearch: PropTypes.object,
  pathname: PropTypes.string,
  savedPublicCollegeSearch: PropTypes.object,
  onSelect: PropTypes.func,
}

export default connect((state) => ({
  savedSearch: get(state, 'savedSearch.query') || get(state, 'user.record.SavedSearch.FacetValues'),
  savedPublicCollegeSearch: selectSavedPublicCollegeSearch(state),
  tntSearchFilterEnabled: isTnTSearchFilterEnabled(state),
}))(StartYourSearch)
